/**
 * Environment helpers — fail loudly when required vars are missing.
 *
 * Doctrine: staging must NEVER silently fall back to production URLs.
 * Every required VITE_* var throws a descriptive error if unset.
 */

export function requireEnv(value: string | undefined | null, name: string): string {
  if (!value || value.trim() === '') {
    throw new Error(
      `[env] Missing required environment variable: ${name}. ` +
      `Configure it in Vercel / Lovable Cloud before building. ` +
      `Refusing to fall back to a production URL.`
    );
  }
  return value;
}

export function getBackendUrl(): string {
  const url = (import.meta.env.VITE_API_URL as string | undefined)
    || (import.meta.env.VITE_BACKEND_URL as string | undefined);
  return requireEnv(url, 'VITE_API_URL (or VITE_BACKEND_URL)');
}

export function getSupabaseUrl(): string {
  return requireEnv(import.meta.env.VITE_SUPABASE_URL as string | undefined, 'VITE_SUPABASE_URL');
}

export function getSupabaseAnonKey(): string {
  return requireEnv(
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined,
    'VITE_SUPABASE_PUBLISHABLE_KEY'
  );
}

export function getSupabaseFunctionsUrl(): string {
  return `${getSupabaseUrl()}/functions/v1`;
}